import { render, staticRenderFns } from "./ListInventory.vue?vue&type=template&id=3142af3a&scoped=true&"
import script from "./ListInventory.vue?vue&type=script&lang=js&"
export * from "./ListInventory.vue?vue&type=script&lang=js&"
import style0 from "./ListInventory.vue?vue&type=style&index=0&id=3142af3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3142af3a",
  null
  
)

export default component.exports